<template>
  <el-input
    v-model="value"
    @input="handleValue"
    :loading="loading"
  />
</template>

<script>

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String
    },
    formId: String
  },
  data() {
    return {
      options: [],
      loading: false,
      list: []
    }
  },
  methods: {
    async handleValue(val) {
      this.$emit('change', val)
      if (!val.trim() || this.formId) {
        return false
      }
      try {
        const { data } = await this.apiHasUser(val)
        // this.$emit('setDisable', { a: 1 })
        this.$emit('setDisable', data)
      } catch ({ msg }) {
        this.$message.error(msg)
      }
    },
    async apiHasUser(val) {
      return await this.$http.get('/account/login-name', {
        params: {
          loginName: val
        }
      })
    }
  }
}
</script>
